<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Goods Receipt #{{data.code}}</h4>
                    <p class="text-subtitle-1">Goods Receipt Information</p>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3" v-if="hasPermission(this.perm.po_good_receipt.post) && data.state_code == stateDraft">
                    <v-btn color="primary" block @click="handlePost" :loading="postLoading">
                        <v-icon left>mdi-post</v-icon>
                        post
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(perm.po_good_receipt.update)">
                    <v-btn depressed block @click="handleEdit">
                        <v-icon left>mdi-pencil</v-icon>
                        edit
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(perm.po_good_receipt.delete)">
                    <v-btn depressed class="error--text" block @click="handleDelete">
                        <v-icon left>mdi-delete</v-icon>
                        delete
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <GoodReceipt :value="data"/>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PAlert from './../../components/common/PAlert'
import GoodReceipt from "./../../components/purchase/GoodReceipt.vue"
import { mapActions, mapGetters } from 'vuex';
export default {
    name: "GoodReceiptDisplayView",
    components: {
        PAlert,
        GoodReceipt
    },
    data(){
        return {
            id: null,
            loading: false,
            postLoading: false,
            data: {

            },
            alert: {
                value: false,
                content: 'Are you sure',
                callback: null
            },
            perm: permissions,
            stateDraft: 1
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        }),
        list() {
            return [
                {
                    text: "Post to Ledger",
                    icon: "mdi-post",
                    callback: this.handlePost,
                    permission: this.hasPermission(this.perm.po_good_receipt.post)
                }
            ]
        },
        menu() {
            return this.list.filter(item => item.permission == true)
        }
    },
    methods: {
        ...mapActions({
            findByID: "purchase/goodReceipt/findByID",
            post: "purchase/goodReceipt/post",
            snackbar: "ui/snackbar/show"
        }),
        getAsync(){
            this.loading = true;
            this.findByID(this.id).then(response => {
                this.data = response.data;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
                }).finally(() => {
                    this.loading = false;
                })
        },
        handleList() {
            this.$router.push({name: "GoodReceiptList"})
        },
        handleEdit() {
            this.$router.push({ name: "GoodReceiptEdit", params: { id : this.id } })
        },
        handlePost() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to post this goods receipt?", callback: this.postAsnyc}
        },
        postAsnyc() {
            this.postLoading = true;
            this.post(this.data).then(response => {
                this.data = response.data;
                this.snackbar({color: "success", text: "Goods Receipt Posted Successfully"});
                setTimeout(() => {
                    this.getAsync();
                }, 800)
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.postLoading = false;
            })
        },
        handleDelete() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to delete", callback: this.deleteGoodReceipt}
        },
        deleteGoodReceipt() {
            this.loading = true
            this.delete(this.data).then(() => {
                this.snackbar({text: "Good Receipt Deleted", color: "success"})
                this.$router.push({ name: "GoodReceiptList"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({text: message, color: "error"})
            }).finally(() => this.loading = false)
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.getAsync()
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.getAsync()
        next();
    }
}
</script>

<style>

</style>